import script from "./FileName.vue?vue&type=script&lang=js"
export * from "./FileName.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__